
import {useState} from 'react'

export const AdminState = () => {
    const [stat, setStat] = useState([
        {id:1, name:'received'},
        {id:2, name:'preparing'},
        {id:3, name:'shipped'},
        {id:4, name:'delivered'},
        {id:5, name:'confirmed'},
    ])

    const [bstat, setBStat] = useState([
        {id:1, name:'Booked'},
        {id:2, name:'Check In'},
        {id:3, name:'Check Out'},
    ])
    //Package Booking
    const [pckg,setPckg] = useState ({name:'',rate:'',discountedRate:''})
    const [errors, setErrors] = useState(false)
    const [open, setOpen] = useState(false); 
    const [openForm, setOpenForm] = useState(false); 
    const [check, setChecked] = useState(true)
    const [btnLoader, setBtnLoader] = useState(false)
    const [confirmCancel, setConfirmCancel] = useState(false)
    const [upd, setUpd] = useState(false)
    const [updateForm, setUpdateForm] = useState(false)
    const [pdata, setPdata] = useState([]) //package List
    const [inclusionList,setInclusionList] = useState([{service_name:'', inclusion_quantity:''}]) 
    const [image, setImage] =useState([])//package List
    const [confirmUpdate, setConfirmUpdate ] =useState(false)
  
    //ORDER LIST
    const [vdata, setVdata] = useState([]) //view data
    const [ldata, setLdata] = useState([]) // list data

    const [inclusion, setInclusion] = useState([])
    const [form, setForm] = useState({
        driver_name:{val:'', stat:false}, 
        contact_no:{val:'', stat:false}, 
        remarks:{val:'', stat:false}
    })

    //REPORTS
    const [sform, setSForm] = useState({
        status: {value:0, msg:'', stat:false },
        from: {value:'', msg:'', stat:false },
        to: {value:'', msg:'', stat:false },
        filterBy: {value:1, msg:'', stat:false },
    })

    const [bsrform, setBSRForm] = useState({
        status: {value:0, msg:'', bstat:false },
        from: {value:'', msg:'', bstat:false },
        to: {value:'', msg:'', bstat:false },
        filterBy: {value:1, msg:'', bstat:false },
    })

    const [sdata, setSdata] = useState([]) // sales report data
    const [bsdata, setBSdata] = useState([]) // bsales report data

    
    return {
        vdata:{data:vdata, set: setVdata},
        ldata:{data:ldata, set: setLdata},
        form:{data:form, set: setForm},
        stat:{data:stat, set: setStat},
        sform:{data:sform, set: setSForm},
        
        bstat:{data:bstat, set: setBStat},
        bsrform:{data:bsrform, set: setBSRForm},
        bsdata:{data:bsdata, set: setBSdata},

        sdata:{data:sdata, set: setSdata},
        pdata:{data:pdata, set: setPdata},
        pckg:{data:pckg, set: setPckg},
        errors: {data: errors, set: setErrors},
        inclusion:{data:inclusion, set: setInclusion},
        open:{data:open, set: setOpen},
        check:{data:check, set: setChecked},
        btnLoader: {data: btnLoader, set: setBtnLoader},
        confirmCancel: {data: confirmCancel, set: setConfirmCancel},
        openForm: {data: openForm, set: setOpenForm},
        upd:{data: upd, set: setUpd},
        updateForm: {data: updateForm, set: setUpdateForm},
        inclusionList:{data:inclusionList, set: setInclusionList},
        image:{data: image, set: setImage},
        confirmUpdate:{data: confirmUpdate, set: setConfirmUpdate}
       
    }
}